import { inject } from '@angular/core';
import { RedirectCommand, Router, type ResolveFn } from '@angular/router';
import { LCPUserService } from 'src/app/shared/services/lcp-user/lcp-user.service';
import { ProjectWageDataFormService } from '../services/project-wage-data-form.service';
import { ProjectFormMode } from '../enums/project-rate-form-mode.enum';
import { catchError, of, switchMap } from 'rxjs';
import { ProjectClassificationRateQueryVars } from '../components/project-classification-rates/interfaces/project-classification-rate-variables.interface';
import { ProjectClassificationRatesService } from '../services/project-classification-rates.service';
import { ProjectWageDataInformationService } from '../services/project-wage-data-information.service';

export const manageProjectWagesResolver: ResolveFn<
  boolean | RedirectCommand
> = (route, state) => {
  const _lcpUserService = inject(LCPUserService);
  const router = inject(Router);
  const formMode = route.paramMap.get('formMode') as ProjectFormMode;
  const legacyProjectId = Number(route.paramMap.get('legacyProjectId'));
  const classificationId = route.paramMap.get('classificationId');
  const projectWageDataFormService = inject(ProjectWageDataFormService);
  const projectWageDataInformationService = inject(
    ProjectWageDataInformationService
  );
  const projectClassificationRatesService = inject(
    ProjectClassificationRatesService
  );
  projectWageDataFormService.setProjectFormStatus(formMode);
  const redirectCommand = new RedirectCommand(
    router.createUrlTree([
      '/setup/prevailing-wage-setup/manage-project-wage-data',
    ])
  );
  projectWageDataInformationService.setLegacyProjectId(legacyProjectId);

  const tenantId = _lcpUserService.getUserTenantIdValue();
  const vars: ProjectClassificationRateQueryVars = {
    tenantId,
    where: {
      and: [
        {
          legacyProjectId: { eq: legacyProjectId },
        },
        {
          classificationRateId: {
            eq: classificationId,
          },
        },
      ],
    },
  };

  if (formMode === ProjectFormMode.Add) {
    return of(true);
  }

  return projectClassificationRatesService
    .getProjectClassificationRates(vars, 'network-only')
    .pipe(
      switchMap(() => {
        if (!formMode) return of(redirectCommand);
        return of(true);
      }),
      catchError(() => of(redirectCommand))
    );
};
